// What a page restored from the back/forward cache must do (all sites, asked by jument). Pure, so it is tested.
//
// `left` is the visitor state when the page was left (`pagehide`), `now` the state when Back/Forward brings
// it back (`pageshow` with `persisted`); both come from `visitor_state_snapshot()`.
//
// "reload": something the page was showing may be wrong — logged in/out or another user, another language,
//           the guest cart changed, a mutation ran in another page or tab, or the page sent the visitor to the
//           bank. The server renders it again.
// "keep":   nothing changed since the page was left; it is shown instantly from memory.
export const bfcache_restore_action = (left = {}, now = {}) => {
	if (left?.must_reload) return "reload";
	if ((left?.token || "") !== (now?.token || "")) return "reload";
	if (left?.locale && now?.locale && left.locale !== now.locale) return "reload";
	if ((left?.local_cart || "") !== (now?.local_cart || "")) return "reload";
	if ((left?.version || "") !== (now?.version || "")) return "reload";
	return "keep";
};
